import { MarketplaceImport } from './Imports'
const { RoutesMap, CropListingList, MarketplaceView } = MarketplaceImport

const MarketplaceRoute = () => {
    return [
        {
            path: RoutesMap.CROP_LISTING_LIST.path,
            element: <CropListingList />
        },


        {
            path: RoutesMap.MARKETPLACE_VIEW.path,
            element: <MarketplaceView />
        },
    ]
}

export default MarketplaceRoute;